<template>
	<div class="parent-quote" @click="$emit('open')">
		<div class="parent-header">
			<ReplyIcon class="parent-icon" />
			<i18n-t keypath="chat_message_quoted_header">
				<div
					class="parent-user"
					v-text="user ? user.fullname : $t('chat_message_unknownuser')"
				/>
			</i18n-t>
		</div>
		<SourceMessagePreview :messageId="messageId" />
	</div>
</template>

<script>
import { getUser, getMessage } from '@/store'
import { ReplyIcon } from '@/icons'
import SourceMessagePreview from './SourceMessagePreview'

export default {
	name: 'ParentQuote',
	props: ['messageId'],
	components: {
		ReplyIcon,
		SourceMessagePreview,
	},

	data() {
		return {
			user: null,
		}
	},

	emits: ['open'],

	mounted() {
		this.updateUser()

		this.$onEventBus({
			'message-change': (ids) => {
				if (ids?.includes(this.messageId)) {
					this.updateUser()
				}
			},
			'user-update': (id) => {
				if (this.userId === id) {
					this.updateUser()
				}
			},
		})
	},

	computed: {
		userId() {
			return getMessage(this.messageId)?.user_id
		},
	},

	methods: {
		updateUser() {
			this.user = getUser(this.userId)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.parent-quote {
	cursor: pointer;
	margin: 10px 0 10px 14px;
	position: relative;
	z-index: 2;
	.parent-header {
		display: flex;
		align-items: center;
		font-size: 12px;
		color: var(--neutral-600);
		font-family: Avenir-Medium;
		margin-left: 8px;
		margin-bottom: 4px;
		max-width: 100%;
		overflow: hidden;
		white-space: nowrap;
		.parent-icon {
			font-size: 18px;
			margin: 0 6px;
			color: var(--teal-300);
		}
		.parent-user {
			margin-left: 4px;
			color: var(--neutral-800);
			max-width: 100%;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			font-family: Avenir-Heavy;
		}
	}
}
</style>
